export const BAD_RECORD_NAMES = [
  'unspecified'
]